
export interface InfoScreenParticipantItem {
  name: string,
  ping: number
}

const UPDATE_RATE_HZ = 2;

class InfoScreen {

  lastUpdated: number = 0;
  items: Array<InfoScreenParticipantItem>;
  domElementScreen: HTMLElement;
  domElementParticipants: HTMLElement;

  constructor() {
    this.domElementScreen = document.getElementById('infoScreen');
    this.domElementParticipants = document.getElementById('infoScreenParticipantItems');
  }

  update(items: Array<InfoScreenParticipantItem>) {
    this.items = items;
    
    const currentTime = new Date().getTime();
    const updateInterval = 1000 / UPDATE_RATE_HZ;
    if(currentTime - this.lastUpdated > updateInterval) {
      this.lastUpdated = currentTime;
      this.updateDomElements();
    }
  }

  updateDomElements() {
    // delete all player items
    while (this.domElementParticipants.firstChild) {
      this.domElementParticipants.removeChild(this.domElementParticipants.lastChild);
    }

    // add player items
    this.items.forEach(item => {
      const container = this.domElementParticipants
      container.insertAdjacentHTML('beforeend', `
        <div class="infoScreenTeamItem">
          <span>${item.name}</span>
          <span>${item.ping}</span>
        </div>
      `);
    })
  }

  show() {
    this.domElementScreen.style.display = 'initial';
  }

  hide() {
    this.domElementScreen.style.display = 'none';
  }

}

export default new InfoScreen();
